module.exports = __webpack_public_path__ + "2e50b0e7f6ad5c5edf5e5158ccbee9e1.png";